<form [formGroup]="adminPasswordForm">
  <andor-text-input
    [control]="adminPasswordForm.controls.password"
    [label]="labelPassword"
    toolTipMsg="{{
      'Set the admin password for the owner team. Once set, you\'re ready to go!' | translate
    }}"
    [type]="'password'"
    autocomplete="new-password"
    errorMsg="{{ 'Use between 6 and 256 characters.' | translate }}"
    placeholder="{{ 'Password' | translate }}"></andor-text-input>
  <andor-text-input
    [control]="adminPasswordForm.controls.confirmPassword"
    [label]="labelConfirmPassword"
    [type]="'password'"
    autocomplete="new-password"
    toolTipMsg="{{ 'Please confirm your password. Make sure to remember it!' | translate }}"
    errorMsg="{{ 'Passwords do not match.' | translate }}"
    placeholder="{{ 'Confirm your password' | translate }}"></andor-text-input>
  @if (adminPasswordForm.controls.password.touched && adminPasswordForm.controls.password.invalid) {
    <p class="password-error" role="alert">{{ 'Use between 6 and 256 characters.' | translate }}</p>
  } @else if (
    adminPasswordForm.controls.confirmPassword.touched &&
    adminPasswordForm.controls.confirmPassword.invalid
  ) {
    <p class="password-error" role="alert">{{ 'Passwords do not match.' | translate }}</p>
  }
</form>
